
import {defineComponent} from "vue";

export default defineComponent({
  name: "Knowledges",
  props: {
    knowledges: { required: true, type: Array }
  }
})
